import VeeValidate, { Validator } from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru'

const dictionary = {
  ru: {
    messages: {
      required: () => 'Обязательное поле',
      email: () => 'Значение должно быть действительным электронным адресом',
      min: (field, length) => `Должно быть не менее ${length} символов`,
      numeric: () => 'Допускаются только числа'
    }
  }
}

Validator.extend('eng', {
  messages: {
    ru: () => 'Допускаются только буквы латинского алфавита'
  },
  validate: value => {
    return /^[a-zA-z]+$/.test(value)
  }
})

Validator.extend('letters_only', {
  messages: {
    ru: () => 'Допускаются только буквы'
  },
  validate: value => {
    return /^[a-zA-zа-яА-Я]+$/.test(value)
  }
})

Validator.extend('date', {
  messages: {
    ru: () => 'Некорректная дата, укажите год полностью'
  },
  validate: value => {
    return /^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/.test(value)
  }
})

Validator.addLocale(ru)
Validator.updateDictionary(dictionary)

export default VeeValidate



// WEBPACK FOOTER //
// ./src/services/Validator.js